import React from 'react';
import { useI18n } from '../useI18n.js';

export function Announcements({ announcements }) {
  const { t } = useI18n();
  return (
    <div className="card" style={{ marginBottom: '1rem', position: 'relative' }}>
      <span className="container-emoji-badge">📢</span>
      <h3>{t('announcements')}</h3>
      <ul>
        {announcements.map((a, i) => <li key={i}>{a}</li>)}
      </ul>
    </div>
  );
}
